"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('speed-one', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(3.000000, 3.000000)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M22.087297,28.673682 C24.7539636,22.813108 26.087297,19.1464413 26.087297,17.673682 C26.087297,15.464543 24.296436,13.673682 22.087297,13.673682 C19.878158,13.673682 18.087297,15.464543 18.087297,17.673682 C18.087297,19.1464413 19.4206303,22.813108 22.087297,28.673682 Z",
    fill: props.outFillColor,
    fillRule: "nonzero",
    transform: "translate(22.087297, 21.173682) scale(1, -1) rotate(-44.000000) translate(-22.087297, -21.173682) "
  }), _react.default.createElement("g", {
    strokeLinecap: props.strokeLinecap
  }, _react.default.createElement("path", {
    d: "M35.8492424,35.8492424 C39.6494949,32.0489899 42,26.7989899 42,21 C42,9.40202025 32.5979797,0 21,0 C9.40202025,0 0,9.40202025 0,21 C0,26.7989899 2.35050506,32.0489899 6.1507576,35.8492424"
  })), _react.default.createElement("path", {
    d: "M21,1 L21,5",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M34.2911352,7.40067337 L34.2911352,11.4006734",
    strokeLinecap: props.strokeLinecap,
    transform: "translate(34.291135, 9.400673) rotate(51.000000) translate(-34.291135, -9.400673) "
  }), _react.default.createElement("path", {
    d: "M37.5737745,21.7828559 L37.5737745,25.7828559",
    strokeLinecap: props.strokeLinecap,
    transform: "translate(37.573775, 23.782856) rotate(103.000000) translate(-37.573775, -23.782856) "
  }), _react.default.createElement("path", {
    d: "M4.42622549,21.7828559 L4.42622549,25.7828559",
    strokeLinecap: props.strokeLinecap,
    transform: "translate(4.426225, 23.782856) rotate(257.000000) translate(-4.426225, -23.782856) "
  }), _react.default.createElement("path", {
    d: "M7.7088648,7.40067337 L7.7088648,11.4006734",
    strokeLinecap: props.strokeLinecap,
    transform: "translate(7.708865, 9.400673) rotate(309.000000) translate(-7.708865, -9.400673) "
  })))));
});

exports.default = _default;